<style scoped>
.header {
    @apply w-48 text-center text-xl font-bold flex-shrink-0;
}
.paragraph {
    @apply text-base;
}
::v-deep .link {
    display: contents;
    @apply text-darkGrayishBlue font-black underline;
}
::v-deep .link:hover {
    @apply text-blue;
}
::v-deep .link:focus {
    @apply outline-none;
}

.content-block {
    & a {
        @apply text-darkGrayishBlue font-black underline !important;
    }
    & a:hover {
        @apply text-blue !important;
    }
    & a:focus {
        @apply outline-none;
    }
}
</style>

<template>
    <contentBlock>
        <div class="bg-primary text-white rounded-xl px-6 py-4">
            <div
                class="flex flex-col sm:flex-row sm:flex-wrap sm:items-center border-4 rounded-lg border-white px-6 py-4"
            >
                <div class="flex-1">
                    <div class="text-2xl font-bold">
                        甚麼是「T-Coins」?
                    </div>
                    <div class="text-lg">
                        T-Coins 是試吓啦平台的電⼦⾦幣，會員能夠透過多個獎賞計劃
                        賺取免費T-Coins，於試吓啦平台消費時當作現⾦使⽤。
                    </div>
                </div>

                <msgSlot
                    :msgKey="'5{0}=$1HKD'"
                    class="flex-shrink-0 ml-4 flex justify-center items-center text-4xl sm:text-5xl font-bold"
                >
                    <template #slot0>
                        <div class="icon h-12 w-12 sm:h-16 sm:w-16">
                            <tryhalaCoinSvg />
                        </div>
                    </template>
                </msgSlot>
            </div>
        </div>

        <div
            class=" flex flex-col items-center mt-8 pt-4 border-t border-gray-100"
        >
            <div class="header my-4">
                T-Coins 獎賞計劃
            </div>
            <div class="text-center text-lg w-full sm:w-7/12">
                T-Coins獎勵計劃不定期更新，會員可透過本頁留意最新的T-Coins獎賞資訊，
                或以電郵形式接收最新的試吓啦獎賞計劃及其他優惠資訊。
            </div>
            <div :class="detailRowClass" v-if="enableWelcomeTcoinAward">
                <div :class="detailRowHeaderClass">
                    迎新獎賞
                </div>
                <div :class="detailRowContentClass">
                    每位新會員都可獲得50個T-Coins獎賞，並即時於試吓啦消費當作現⾦使⽤，讓您立即體驗購物旅程。
                </div>
            </div>
            <div :class="detailRowClass">
                <div :class="detailRowHeaderClass">
                    介紹新公司獎賞
                </div>
                <div :class="detailRowContentClass">
                    成功介紹一間新公司，並有5位登記做會員，即獲500個T-Coins獎賞。
                    <a
                        target="_blank"
                        href="https://wa.me/85252398123?text=%E6%88%91%E6%83%B3%E4%BA%86%E8%A7%A3%E5%A6%82%E4%BD%95%E6%8E%A8%E4%BB%8B%E6%96%B0%E5%85%AC%E5%8F%B8%E8%B3%BA500tcoins"
                    >
                        聯絡我們
                    </a>
                </div>
            </div>
            <div :class="detailRowClass" v-if="enableBirthdayTcoinAward">
                <div :class="detailRowHeaderClass">
                    生日月份獎賞
                </div>
                <div :class="detailRowContentClass">
                    <msgSlot
                        msgKey="提供生日月份的會員能夠於該生日月份獲得100T-Coins獎賞。您可從「{0}」 提交生日月份。"
                    >
                        <template #slot0>
                            <router-link
                                tag="button"
                                to="/account/accountInfo"
                                class="link"
                            >
                                帳戶資料
                            </router-link>
                        </template>
                    </msgSlot>
                </div>
            </div>
            <div :class="detailRowClass">
                <div :class="detailRowHeaderClass">
                    產品體驗回饋
                </div>
                <div :class="detailRowContentClass">
                    <msgSlot
                        msgKey="會員收到產品約一星期後可於「{0}」回答簡單問卷賺取T-Coins，回答每條問題可獲得1個T-Coin。"
                    >
                        <template #slot0>
                            <router-link
                                tag="button"
                                to="/account/feedback"
                                class="link"
                            >
                                產品體驗回饋
                            </router-link>
                        </template>
                    </msgSlot>
                </div>
            </div>
            <div :class="detailRowClass">
                <div :class="detailRowHeaderClass">消費獎賞</div>
                <div :class="detailRowContentClass">
                    每消費$20便可獲得1個T-Coin，相等於1%消費回贈！不同訂單的消費不能合併賺取
                    T-Coins。
                </div>
            </div>
        </div>
    </contentBlock>
</template>

<script>
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import contentBlock from './contentBlock.vue';
import msgSlot from './msgSlot';

export default {
    components: {
        tryhalaCoinSvg,
        contentBlock,
        msgSlot
    },
    data() {
        return {
            detailRowClass:
                'w-full flex flex-col items-center sm:flex-row p-8 sm:py-0 border-4 border-primary rounded-lg mt-4',
            detailRowHeaderClass:
                'header sm:my-2 sm:py-6 sm:border-r-2 sm:border-gray-100',
            detailRowContentClass: 'paragraph sm:ml-4'
        };
    },
    computed: {
        enableWelcomeTcoinAward() {
            return this.$store.state.enableWelcomeTcoinAward;
        },
        enableBirthdayTcoinAward() {
            return this.$store.state.enableBirthdayTcoinAward;
        }
    }
};
</script>
